<template>
  <el-menu :default-active="global.index" class="el-menu-vertical-demo">
    <el-menu-item @click='store' index="Home">
      <router-link to="/main"><el-icon><HomeFilled /></el-icon>Home</router-link>
    </el-menu-item>
    <el-sub-menu index="3">
      <template #title>
        <el-icon><Money /></el-icon>
        <span>Expense / Investment</span>
      </template>
      <el-menu-item @click='store'  index="contract" v-if="global.hasRight('contract', 'normal') || global.hasRight('contract', 'admin')" >
        <router-link to="/contract/allContracts">Contract</router-link>
      </el-menu-item>
      <el-menu-item @click='store' index="expense">
        <router-link v-if="global.hasRight('expense', 'approver') || global.hasRight('expense', 'statistician')" 
          to="/expense/allExpenseList">Expenses</router-link>
        <router-link v-else to="/expense/myExpenseList">My Expenses</router-link>
      </el-menu-item>
      <el-menu-item @click='store' index="payment">
        <router-link v-if="global.hasRight('payments', 'approver') || global.hasRight('payments', 'statistician')" 
          to="/payment/allPaymentList">Payment</router-link>
        <router-link v-else to="/payment/myPaymentList">Payment</router-link>
      </el-menu-item>
      <el-menu-item @click='store' index="procurement">
        <router-link v-if="global.hasRight('printing-procurement', 'approver') || global.hasRight('printing-procurement', 'statistician')" 
          to="/procurement/allProcurementList">Printing / Procurement</router-link>
        <router-link v-else to="/procurement/myProcurementList">Printing / Procurement</router-link>
      </el-menu-item>
      <el-menu-item @click='store' index="investment">
        <router-link v-if="global.hasRight('personal-investment', 'approver')" to="/investment/allInvestmentList">Personal Investments</router-link>
        <router-link v-else to="/investment/myInvestmentList">Personal Investments</router-link>
      </el-menu-item>
    </el-sub-menu>

    <el-sub-menu index="2">
      <template #title>
        <el-icon><document /></el-icon>
        <span>Monthly Report</span>
      </template>
      <el-menu-item @click='store' index="report-Factsheet">
        <router-link to="/report/reportList?reportType=Factsheet">Factsheet</router-link>
      </el-menu-item>
      <el-menu-item @click='store' index="report-Leaflet">
        <router-link to="/report/reportList?reportType=Leaflet">Leaflet</router-link>
      </el-menu-item>
      <el-menu-item @click='store' index="report-APxJ">
        <router-link to="/report/reportList?reportType=APxJ">Asia Pacific Index</router-link>
      </el-menu-item>
    </el-sub-menu>

    <el-sub-menu index="4">
      <template #title>
        <el-icon><microphone /></el-icon>
        <span>Event / Media</span>
      </template>
      <el-menu-item @click='store' index="event">
        <router-link v-if="global.hasRight('event-interview', 'approver') || global.hasRight('event-interview', 'admin')" 
          to="/log/allEventList">Event</router-link>
        <router-link v-else to="/log/myEventList">Event</router-link>
      </el-menu-item>
      <el-menu-item @click='store' index="interview">
        <router-link v-if="global.hasRight('event-interview', 'approver') || global.hasRight('event-interview', 'admin')" 
          to="/log/allInterviewList">Interview</router-link>
        <router-link v-else to="/log/myInterviewList">Interview</router-link>
      </el-menu-item>
    </el-sub-menu>

    <el-sub-menu index="6">
      <template #title>
        <el-icon><Reading /></el-icon>
        <span>Documents</span>
      </template>
      <el-menu-item @click='store' index="deck">
        <router-link v-if="global.hasRight('deck-docs', 'compliance')" to="/deck/allDeckDocuments">Deck Docs</router-link>
        <router-link v-else to="/deck/myDeckDocuments">Deck Docs</router-link>
      </el-menu-item>
      <el-menu-item @click='store' index="companyDoc">
        <router-link to="/companyDoc/allCompanyDocs">Company Docs</router-link>
      </el-menu-item>
    </el-sub-menu>

    <el-sub-menu index="1">
      <template #title>
        <el-icon><Reading /></el-icon>
        <span>Website CMS</span>
      </template>
      <el-menu-item @click='store' index="website-backend">
        <a v-if="global.hasRight('website-backend', 'admin')" :href="global.cms_domain" target="_blank">Website backend</a>
        <span v-else class="noAuth">Website Backend</span>
      </el-menu-item>
      <el-menu-item @click='store' index="insight-publish">
        <a v-if="global.hasAuth('insight-publish')" :href="global.cms_domain + '/insight/insightWorkflowList'" target="_blank">Insight Workflow</a>
        <span v-else class="noAuth">Insight Workflow</span>
      </el-menu-item>
      <el-menu-item @click='store' index="weeky">
        <a :href="global.cms_domain + '/weekly/weeklyList'" 
          v-if="global.hasRight('website-backend', 'distribution') || global.hasRight('website-backend', 'compliance')" target="_blank">Weekly chart</a>
        <span v-else class="noAuth">Other Articles</span>
      </el-menu-item>
    </el-sub-menu>

    <el-sub-menu index="5">
      <template #title>
        <el-icon><avatar /></el-icon>
        <span>User Manage</span>
      </template>
      <el-menu-item @click='store' index="user">
        <router-link v-if="global.hasAuth('premia-user')" to="/auth/userList">User List</router-link>
        <span v-else class="noAuth">User List</span>
      </el-menu-item>
      <el-menu-item @click='store' index="auth">
        <router-link to="/auth/authorizeByUser" v-if="global.hasAuth('premia-user')">Authorization</router-link>
        <span v-else class="noAuth">Authorization</span>
      </el-menu-item>
    </el-sub-menu>
    
  </el-menu>
</template>

<script>
import { Reading, Document, Money,  Microphone, Avatar, HomeFilled } from '@element-plus/icons-vue'
import global from '@/common/global.js'

export default {
    components: {
        Reading, Document, Money, Microphone, Avatar, HomeFilled,
    },
    data() {
      return {
        global,
      }
    },
    methods: {
      store(event) {
        localStorage.setItem("lastIndex", event.index);
      }
    },
    created() {
      let index = localStorage.getItem("lastIndex");
      if (index) {
        this.global.index = index;
      }
    },
}
</script>

<style>
  .is-active {
    background:#e6f2ff;
  }
  .is-active i, .is-active .el-sub-menu__title {
    color:#01b1af;
  }
  .el-menu-item.is-active, .el-menu-item.is-active a {
    color:#01b1af;
  }
  .is-opened, .el-sub-menu__title {
    background:#ffffff;
  }
  .el-sub-menu .el-menu-item {
    min-width: 150px;
    height:40px;
    line-height:40px;
  }
  .el-menu-item a {
    text-decoration: none;
    color:#555;
  }
  .el-sub-menu__title {
    line-height:45px;
    font-weight:bold;
    color:#555;
    background:#f9f9f9;
  }
  .noAuth {
    cursor: not-allowed;
    color:#bbb;
  }
</style>